// Module
var code = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <rect x=\"4.5\" y=\"4.5\" width=\"11\" height=\"11\" rx=\"5.5\" stroke=\"white\"/> </svg> ";
// Exports
module.exports = code;